/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 17/1/2022
 */

import {PaletteEnum} from "@/core/js/PaletteEnum";

// export const TimeLineItemColors = Object.freeze({
// 	2: PaletteEnum.DANGER,
// 	5: PaletteEnum.WARNING,
// 	6: PaletteEnum.DISABLED,
// 	9: PaletteEnum.SUCCESS_LIGHT,
// 	11: PaletteEnum.SUCCESS
// })
export const TimeLineItemColors = Object.freeze({
	1: PaletteEnum.DANGER,
	3: PaletteEnum.WARNING,
	4: PaletteEnum.DISABLED,
	6: PaletteEnum.SUCCESS_LIGHT,
	7: PaletteEnum.SUCCESS
})
